// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import 'tippy.js/dist/tippy.css';

require('@rails/ujs').start();
require('@rails/activestorage').start();
require('turbolinks').start();
require('channels');
require('jquery');
require('jquery-ui');
// const WaveSurfer = require('wavesurfer.js');

// IDK what this is
require('../webaudio');

// For UI
require('common/ui');

require('webrtc'); // needed for "SetupEngine"

// timeago for how long has passed since date, used for audiorecordings
// maybe this is not needed
require('utils/timeago');


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

// VUE
// Vue specific stuff
// Split VUE into Mirror/Anywhere/Presenter and Common?
require('main');

// To handle navigation events
require('navigation');

require ("vue-components")